import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

import { KEYS } from '~shared/api/query-keys';

export const updateUserRoleAPI = async (userId: string, roleId: string) => {
  await baseAPI.patch(`/users/${userId}/access`, {
    roleId,
  });
  return;
};

export const useUpdateUserRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, roleId }: { userId: string; roleId: string }) =>
      updateUserRoleAPI(userId, roleId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.USERS],
      });
    },
  });
};
